import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { AdminAddGpsComponent } from "../admin-add-gps/admin-add-gps.component";
import { AdminAddNotesComponent } from "../admin-add-notes/admin-add-notes.component";
import { AdminGenerateDeviceComponent } from "../admin-generate-device/admin-generate-device.component";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-gps",
  templateUrl: "./admin-gps.component.html",
  styleUrls: ["./admin-gps.component.css"],
})
export class AdminGpsComponent implements OnInit {
  matdialogref!: MatDialogRef<AdminAddGpsComponent>;
  token: any;
  gpsSelectedIds: any;
  SelectedNumber: number = 0;
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  total_cat_count: any;
  GpsList: any = [];
  toggleSearch: boolean = false;
  searchButton: boolean = true;
  gpsName: any = -1;
  perpage: any = 10;
  page: any = 1;
  loading: boolean = false;
  addBtn: boolean = true;
  selectGps: boolean = true;
  cancelGps: boolean = false;
  deleteGps: boolean = false;
  deleteAction: boolean = false;
  checkBox: boolean = false;
  search_btn: boolean = false;
  clear_Btn: boolean = false;
  @ViewChild("newItem") newItem: ElementRef;
  constructor(
    private matDialog: MatDialog,
    private service: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.GetGps(this.gpsName);
    this.pagination(1);
    let triptype = "gps";
    localStorage.setItem("tripType", triptype);
  }

  onInputChange(value: any) {
    if (value.length === 0) {
      this.resetSearch();
    }
  }

  public GetGps(type: any) {
    this.gpsName = type;
    this.loading = true;
    this.service
      .GetGps(this.token, this.gpsName, this.perpage, this.startPage)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.GpsList = response.body.data;
            this.document_array.push(response.body.meta);
            this.last_page = response.body.meta.lastPage;
          }
        },
        (error) => {
          this.loading = false;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  refresh() {
    this.GetGps(this.gpsName);
  }

  GoToAddGps(type: any, data: any) {
    this.matdialogref = this.matDialog.open(AdminAddGpsComponent, {
      width: "40vw",
      data: {
        type: type,
        data: data,
      },
      autoFocus: false,
    });
    this.matdialogref.afterClosed().subscribe((res) => {
      this.GetGps(this.gpsName);
    });
  }

  public autoGeneratedDevice() {
    let matDia = this.matDialog.open(AdminGenerateDeviceComponent, {
      width: "40vw",
      data: "",
      autoFocus: false,
    });
  }

  public onSelect() {
    this.selectGps = false;
    this.cancelGps = true;
    this.deleteGps = true;
    this.deleteAction = true;
    this.checkBox = true;
    this.addBtn = false;
    this.searchButton = false;
  }

  public matItem(event: any, item: any, index: number) {
    if (event.checked) {
      this.gpsSelectedIds = item;
      this.SelectedNumber += 1;
    } else {
      this.gpsSelectedIds.splice(index, 1);
      this.SelectedNumber -= 1;
    }
  }

  public onSelectCancel() {
    this.gpsName = -1;
    this.gpsSelectedIds = [];
    this.SelectedNumber = 0;
    this.cancelGps = false;
    this.selectGps = true;
    this.deleteGps = false;
    this.checkBox = false;
    this.toggleSearch = false;
    this.searchButton = true;
    this.deleteAction = false;
    this.addBtn = true;
    this.GetGps(this.gpsName);
  }

  public onDelete() {
    this.service.DeleteGps(this.gpsSelectedIds, this.token).subscribe(
      (response: any) => {
        if (response.status === 200 || response.status === 201) {
          this.onSelectCancel();
          this.snackBar.open("GPS deleted successfully", "Success", {
            duration: 5000,
          });
          this.GetGps(this.gpsName);
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public addNotes(gpsId: any) {
    let matDialogref = this.matDialog.open(AdminAddNotesComponent, {
      width: "40vw",
      data: {
        _id: gpsId,
        module_type: "gps",
      },
      autoFocus: false,
    });
    matDialogref.afterClosed().subscribe((res) => {
      this.GetGps(this.gpsName);
    });
  }

  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.GetGps(this.gpsName);
  }

  openSearch() {
    this.search_btn = true;
    this.clear_Btn = false;
    this.toggleSearch = true;
    this.searchButton = false;
    this.addBtn = false;
    this.cancelGps = true;
    this.deleteGps = true;
    this.selectGps = false;
    this.checkBox = true;
    this.deleteAction = true;
  }

  search(value: string) {
    if (value != "") {
      this.search_btn = false;
      this.clear_Btn = true;
      this.searchButton = false;
      this.GetGps(value);
    }
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.gpsName = "";
    this.GetGps(this.gpsName);
    this.searchButton = true;
    this.toggleSearch = false;
    this.addBtn = true;
    this.selectGps = true;
    this.cancelGps = false;
    this.deleteGps = false;
    this.deleteAction = false;
    this.checkBox = false;
  }
}
